<template>
  <Toast/>
  <div class="row">
    <div class="col titre">
      <h2>Province</h2>
    </div>
  </div>
  <div class="row">
    <div class="col-4 lbl">
      <label>Pays :</label>
    </div>
    <div v-if="!libellesPaysLoading" class="col-4">
      <Dropdown class="dropdown-height"
                v-model="ascendantCle"
                :options="paysLibelles"
                :filter="true"
                optionValue="valeur"
                optionLabel="texte"
                scrollHeight="205px"
                :showClear="true"/>
    </div>
    <div v-else class="col-4">
      <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
    </div>
  </div>
  <div class="row">
    <div class="col-4 lbl">
      <label>Province :</label>
    </div>
    <div class="col-4">
      <InputText v-model="province"/>
    </div>
  </div>
  <div class="row solid-line"/>
    <div class="row">
      <div class="col">
        <div v-if="enregistrementEnCours == false">
          <Button @click="sauvegarder">Sauvegarder</Button>
        </div>
        <div v-else>
          <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
        </div>
      </div>
    <div class="col">
      <Button @click="fermer">Fermer</Button>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import axios from 'axios';

export default {
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Ajout Province");
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.libellesPaysLoading = true;
    this.$store.dispatch("pilotage/rechercherTableValeurSansAscAction", 'Pays').then((res) => {
      this.paysLibelles = res.data;
      this.paysLibelles.sort(function (a, b) {
        if (a.texte < b.texte) {
          return -1;
        }
        if (a.texte > b.texte) {
          return 1;
        }
        return 0;
      });
      this.libellesPaysLoading = false;
    });
  },
  data(){
    return {
      ascendantCle: null,
      province: null,
      enregistrementEnCours: false,
      code: 'Province',
      paysLibelles: [],
      libellesPaysLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  methods: {
    sauvegarder(){
      if(this.ascendantCle != null){
        this.enregistrementEnCours = true;

        let tableValeurLocal = {};
        tableValeurLocal.tableValeurVO = {};
        tableValeurLocal.tableValeurVO.code = this.code;
        tableValeurLocal.tableValeurVO.description = this.province;
        tableValeurLocal.tableValeurVO.actif = true;
        tableValeurLocal.libelleVO = {};
        tableValeurLocal.libelleVO.texte = this.province;

        this.$store.dispatch('pilotage/ajouterTableValeurAction', {
            ascendantCle: this.ascendantCle,
            tableValeur: tableValeurLocal
        }).then(() => {
          this.enregistrementEnCours = false;
          this.$toast.add({
              severity: 'success',
              summary: 'Sauvegarder',
              detail: 'La province a été ajoutée',
              life: 6000
          })
        }).catch(err => {
          this.$toast.add({
              severity: 'error',
              summary: 'Sauvegarder',
              detail: `Erreur lors de l'enregistrement du type: ${err}`,
              life: 6000
          })
          this.enregistrementEnCours = false;
        })
      }else {
        this.$toast.add({
            severity: 'error',
            summary: 'Sauvegarder',
            detail: 'Il faut un pays pour ajouter la province',
            life: 6000
        })
      }
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    }
  }
    
}
</script>
